import { render } from "./AcompanharView.vue?vue&type=template&id=606cd98d&scoped=true&ts=true"
import script from "./AcompanharView.vue?vue&type=script&lang=ts"
export * from "./AcompanharView.vue?vue&type=script&lang=ts"

import "./AcompanharView.vue?vue&type=style&index=0&id=606cd98d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1991399693/src/agendamento-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606cd98d"]])

export default __exports__